module.exports = __webpack_public_path__ + "img/4.702afb36.jpg";